import { lazy } from 'react';

export default lazy(() => import('mfClientReporting/ClientReporting'));
